module.exports = __webpack_public_path__ + "img/salesforce_logo_big.a96b1fa3.png";